// @flow

import authApiService from './auth-api-service';

import type { NewRequestSubmission, InformationRequest } from '../types/request';
import type { StatusHistory, AllStatuses } from '../types/status';

class RecordRequestService {
  create(submission: NewRequestSubmission[]): Promise<InformationRequest[]> {
    return authApiService
      .post('/connect-provider-addresses', { requests: submission })
      .then((response) => response.information_requests)
      .catch((err) => {
        throw new Error(err);
      });
  }

  all(ids: string = ''): Promise<InformationRequest[]> {
    return authApiService
      .get(`/information_requests${ids}`)
      .then((response) => response.information_requests);
  }
  delete(id: number): Promise {
    return authApiService
      .delete(`/information_request/${id}`)
      .then((response) => response);
  }

  show(id: number): Promise<InformationRequest> {
    return authApiService
      .get(`/information_request/${id}`)
      .then((response) => response.information_request);
  }

  signRequests(requestIds: number[], signatureId: number): Promise<InformationRequest[]> {
    const patches = requestIds.map((id) => ({
      id,
      signature_id: signatureId
    }));

    return authApiService.patch('/information_requests', { information_requests: patches })
      .then((response) => response)
      .catch((err) => err);
  }

  status(id: number): Promise<StatusHistory[]> {
    return authApiService.get(`/information_request/${id}/?include=status_history`)
      .then((response) => response.information_request)
      .catch((error) => error);
  }

  allStatus(ids: string[]): Promise<AllStatuses[]> {
    return authApiService
      .get(`/information_requests?${ids}&include=status_history`)
      .then((response) => response.information_requests)
      .catch((error) => error);
  }
}

export default new RecordRequestService();


// WEBPACK FOOTER //
// ./src/services/record-request-service.js